import * as React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

const StyledUl = styled.ul`
  list-style-type: none;
  margin: 0;
`

const StyledLi = styled.li`
  min-width: 167px;
`

const StyledLink = styled(Link)`
  color: #000;
  text-decoration: none;
`

const Surgery = () => (
  <StyledLi>
    <strong>Cosmetic Surgery</strong>
    <StyledUl>
      <li>
        <StyledLink to="/laser-eyelid-festoons">
          RESET Festoons
        </StyledLink>
      </li>
      <li>
        <StyledLink to="/facial-plastic-surgery-in-tampa/reset-skin-resurfacing">
          RESET Full Face
        </StyledLink>
      </li>
      <li>
        <StyledLink to="/reset-upper-lids">
          RESET Upper Lids
        </StyledLink>
      </li>
      <li>
        <StyledLink to="/upper-and-lower-eyelid-laser-surgery">
          Upper and Lower Eyelid Laser Surgery
        </StyledLink>
      </li>
      <li>
        <StyledLink to="/the-better-blepharoplasty">
          The Better Blepharoplasty
        </StyledLink>
      </li>
      <li>
        <StyledLink to="/facial-plastic-surgery-in-tampa/brow-lift-in-tampa-florida">
          Browlift
        </StyledLink>
      </li>
    </StyledUl>
  </StyledLi>
)

export default Surgery
